import { SendOption } from "./types";
import dayjs from "dayjs";
import AppDatePicker from "../../../../components-ui/AppDatePicker";
import AppTimePicker from "../../../../components-ui/AppTimePicker";

interface SendOptionsCardProps {
  sendOption: SendOption;
  scheduledDate: string;
  scheduledTime: string;
  onSendOptionChange: (value: SendOption) => void;
  onScheduledDateChange: (value: string) => void;
  onScheduledTimeChange: (value: string) => void;
}

export default function SendOptionsCard({
  sendOption,
  scheduledDate,
  scheduledTime,
  onSendOptionChange,
  onScheduledDateChange,
  onScheduledTimeChange,
}: SendOptionsCardProps) {
  return (
    <div className="card">
      <div className="card-title">Send Options</div>

      <div className="form-group">
        <label className="form-label">
          <input
            type="radio"
            name="sendOption"
            checked={sendOption === "now"}
            onChange={() => onSendOptionChange("now")}
          />{" "}
          Send Now
        </label>
      </div>

      <div className="form-group">
        <label className="form-label">
          <input
            type="radio"
            name="sendOption"
            checked={sendOption === "schedule"}
            onChange={() => onSendOptionChange("schedule")}
          />{" "}
          Schedule
        </label>
      </div>

      {sendOption === "schedule" && (
        <div className="form-row">
          <div className="form-group">
            <label className="form-label">Date</label>
            <AppDatePicker
              value={scheduledDate}
              minDate={dayjs()}
              onChange={(value) => onScheduledDateChange(value ?? "")}
            />
          </div>

          <div className="form-group">
            <label className="form-label">Time</label>
            <AppTimePicker
              value={scheduledTime}
              onChange={(value) => onScheduledTimeChange(value ?? "")}
            />
          </div>
        </div>
      )}
    </div>
  );
}
